import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { useNavigate } from "react-router-dom";

import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import ProjectCard3D from "../ProjectCard3D";

import LightningCaseStudy from "../../../../assets/images/caseStudies/lightning/L10.png";
import MedcoCaseStudy from "../../../../assets/images/LandingPage/caseStudyMedcoPNG.png";

function CaseStudies() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background: "#fff",
        position: "relative",
        zIndex: 10,
      }}
    >
      <Container>
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <MKTypography
            variant="h2"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "2rem", sm: "2.6rem", md: "3.2rem" },
              color: "#0b1020",
              lineHeight: 1.15,
              mb: 2,
            }}
          >
            The Proof is Live
          </MKTypography>
          <MKTypography
            variant="body1"
            sx={{
              color: "#7b809a",
              fontSize: { xs: "1rem", md: "1.1rem" },
              maxWidth: 520,
              mx: "auto",
              lineHeight: 1.7,
            }}
          >
            Not mockups. Not demos. Production systems running real businesses —
            right now.
          </MKTypography>
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
          <Grid item xs={12} md={5}>
            <Card
              onClick={() => navigate("/case-studies/medco")}
              sx={{
                height: "100%",
                borderRadius: 4,
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
                transition: "all 0.4s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 36px rgba(102, 126, 234, 0.18)",
                },
              }}
            >
              <ProjectCard3D title="Med-CO" image={MedcoCaseStudy} />
              <Box sx={{ p: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    mb: 1.5,
                  }}
                >
                  <MKTypography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#344767",
                      lineHeight: 1.2,
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                      textAlign: { xs: "center", sm: "left" },
                    }}
                  >
                    MedCo: 5× Growth Through Centralized Operations
                  </MKTypography>
                  <Box
                    sx={{
                      px: 1.2,
                      py: 0.2,
                      background:
                        "linear-gradient(135deg, #667eea15, #764ba215)",
                      borderRadius: 2,
                      flexShrink: 0,
                    }}
                  >
                    <MKTypography
                      variant="caption"
                      sx={{
                        color: "#667eea",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        fontSize: "0.6rem",
                      }}
                    >
                      Healthcare
                    </MKTypography>
                  </Box>
                </Box>
                <MKTypography
                  variant="body2"
                  sx={{
                    color: "#7b809a",
                    lineHeight: 1.5,
                    mb: 2,
                    fontSize: { xs: "0.875rem", md: "0.95rem" },
                  }}
                >
                  How Elagi transformed from manual chaos to a structured,
                  scalable clinic operation, achieving five times its previous
                  operational capacity.
                </MKTypography>
                <MKButton
                  variant="contained"
                  sx={{
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg,#0b1020 0%,#2b0057 100%)",
                    color: "#fff",
                    px: 2,
                    "&:hover": { boxShadow: "0 10px 30px rgba(43,0,87,0.45)" },
                  }}
                >
                  Read Full Case Study →
                </MKButton>
              </Box>
            </Card>
          </Grid>

          <Grid item xs={12} md={5}>
            <Card
              onClick={() => navigate("/case-studies/lightning")}
              sx={{
                height: "100%",
                borderRadius: 4,
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
                transition: "all 0.4s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 36px rgba(245, 87, 108, 0.18)",
                },
              }}
            >
              <ProjectCard3D title="Lightning OS" image={LightningCaseStudy} />
              <Box sx={{ p: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    mb: 1.5,
                  }}
                >
                  <MKTypography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#344767",
                      lineHeight: 1.2,
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                    }}
                  >
                    LightningOS: Multi-State Sales Dominance
                  </MKTypography>
                  <Box
                    sx={{
                      px: 1.2,
                      py: 0.2,
                      background:
                        "linear-gradient(135deg, #f093fb15, #f5576c15)",
                      borderRadius: 2,
                      flexShrink: 0,
                    }}
                  >
                    <MKTypography
                      variant="caption"
                      sx={{
                        color: "#f5576c",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        fontSize: "0.6rem",
                      }}
                    >
                      Sales & Telecom
                    </MKTypography>
                  </Box>
                </Box>
                <MKTypography
                  variant="body2"
                  sx={{
                    color: "#7b809a",
                    lineHeight: 1.5,
                    mb: 2,
                    fontSize: { xs: "0.875rem", md: "0.95rem" },
                  }}
                >
                  From fragmented operations to full visibility: How Lightning
                  eliminated revenue leaks and scaled across multiple states
                  with LightningOS.
                </MKTypography>
                <MKButton
                  variant="contained"
                  sx={{
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg,#0b1020 0%,#2b0057 100%)",
                    color: "#fff",
                    px: 2,
                    "&:hover": { boxShadow: "0 10px 30px rgba(43,0,87,0.45)" },
                  }}
                >
                  Read Full Case Study →
                </MKButton>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default CaseStudies;
